/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useState } from 'react'
import { useAtom } from 'jotai'
import {
    SortCasesProperties,
    SortCaseProperty,
    SortCasesDirection,
} from '../utils/sortCasesHelper'

import {
    sortedCasesAtom,
    sortedOpenCasesAtom,
    sortedClosedCasesAtom,
} from '../store/filter/filterCasesAtom'

type SortScope = 'open' | 'closed'

const useSortCasesList = (scope?: SortScope) => {
    // Choose the appropriate atom based on scope
    const getSortAtom = () => {
        switch (scope) {
            case 'open':
                return sortedOpenCasesAtom
            case 'closed':
                return sortedClosedCasesAtom
            default:
                return sortedCasesAtom
        }
    }

    const [, setSortedAtom] = useAtom(getSortAtom())

    // Use a state that's scoped to the component instance
    const [sortState, setSortState] = useState<SortCaseProperty | undefined>(
        undefined
    )

    const setSort = (property: SortCasesProperties): void => {
        if (sortState && sortState.property === property) {
            const newSort = {
                direction: sortState.direction === 'Asc' ? 'Desc' : 'Asc',
                property,
            } as SortCaseProperty

            setSortState(newSort)
            setSortedAtom(newSort)
        } else {
            const newSort = {
                direction: 'Asc',
                property,
            } as SortCaseProperty

            setSortState(newSort)
            setSortedAtom(newSort)
        }
    }

    return {
        sortState,
        setSort,
        setSortState,
    }
}

export default useSortCasesList
